import React from "react";
import { withRouter } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import $ from "jquery";
import { getServiceTypeList } from "../Actions/CommonAPI";
import { OverlayTrigger, Popover } from "react-bootstrap";

class VendorCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      isView: false,
    };
  }
  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(getServiceTypeList());
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }
  resize = () => {
    if (window.innerWidth > 987) {
      this.setState({
        isView: true,
      });
    } else {
      this.setState({
        isView: false,
      });
    }
  };
  EquipmentTable(equipmentName, equipmentId) {
    const { dispatch } = this.props;
    localStorage.setItem("EquipmentNameId", equipmentId);
    localStorage.setItem("EquipmentName", equipmentName);
    dispatch({ type: "ShowEquipmentName", data: equipmentName });
    this.props.history.push("/Home/Vendor/EquipmentList");
  }
  ZoneTable(zoneName, ZoneId) {
    localStorage.setItem("ZoneNameId", ZoneId);
    localStorage.setItem("ZoneName", zoneName);
    this.props.history.push("/Home/Vendor/ZoneList");
  }
  VendorTable(vendorName) {
    localStorage.setItem("VendorName", vendorName);
    this.props.history.push("/Home/VendorList");
  }
  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("VendorManagementScreenContent.ViewVendorDetails")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  
  renderdelete(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("VendorManagementScreenContent.DeleteVendorDetails")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  render() {
    const { arraylist,currentPage, pageSize, totalRecords, t } = this.props;
    return (
      <div className="pb-3">
        {this.renderCardData()}
        {arraylist && arraylist.length != 0 ? (
          <Paginator
            first={currentPage}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !--{t("CommonText.NoItem")} --!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const {
      showSidePane,
      arraylist,
      eyeclick,
      deleteVendor,
      applicableServiceType,
      classes,
      menuToggle,
      t
    } = this.props;
    return arraylist && arraylist.length ? (
      <div
        className="col-12 pt-4 px-4 py-3"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <div
          className={`${window.innerWidth < 1000
              ? ""
              : this.state.isView === false
                ? "table-container2"
                : "table-container1"
            } table-responsive`}
        >
          <table id="tableview" className="table cellborder">
            <thead>
              <tr className="table-active section-color border">
                <th
                  className={`${window.innerWidth < 1000 ? "border-left" : "sl-no"
                    } text-center align-middle border-right border-left border-top  plan-color`}
                  style={{
                    minWidth: "250px",
                    maxWidth: "250px",
                    width: "250px",
                  }}
                >
                  <span className="spandoc-thead">{t("ShipEquipmentStatusScreen.EquipmentName")} </span>
                </th>
                <th
                  className={`${window.innerWidth < 1000 ? "" : "vendor-tr-title"
                    } text-center align-middle border-right border-left border-top  plan-color`}
                  style={{
                    minWidth: "170px",
                    maxWidth: "170px",
                    width: "170px",
                  }}
                >
                  <span className="spandoc-thead">{t("VendorManagementScreenContent.ZoneName")}</span>
                </th>
                <th
                  className={`${window.innerWidth < 1000 ? "border-right" : ""
                    } border-top border-right text-center align-middle border-left  align-middle  plan-color`}
                >
                  {" "}
                  <span className="spandoc-thead">{t("VendorManagementScreenContent.VendorName")}</span>
                </th>
                <th
                  className={`${window.innerWidth < 1000 ? "border-right" : "action"
                    } border-top border-right text-center align-middle border-left  plan-color`}
                  style={{
                    minWidth: "100px",
                    maxWidth: "100px",
                    width: "100px",
                  }}
                >
                  <span className="spandoc-thead">{t("VendorManagementScreenContent.Action")}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {arraylist ? (
                arraylist &&
                arraylist.map((item, index) => {
                  return (
                    <>
                      <tr className="border-top border-bottom border-left border-right">
                        <td
                          className={`${window.innerWidth < 1000 ? "border-left" : "sl-no"
                            } text-center align-middle spanTopBar border-right border-left border-bottom`}>
                          <span
                            className="spanTopBar vendor-color"
                            style={{ color: "#000000", cursor: "pointer", textDecorationLine: "underline" }}
                            onClick={() => this.EquipmentTable(item?.equipmentName, item?.equipmentId)}>
                            {item.equipmentName}
                          </span>
                        </td>
                        <td
                          className={`${window.innerWidth < 1000 ? "" : "vendor-tr-title"} text-center align-middle spanTopBar border-right border-bottom border-left px-0`} >
                          {item?.applicableZones.map((i, ind) => (
                            <tr
                              className={`${item?.applicableZones.length - 1 !== ind ? "border-bottom" : ""} d-flex justify-content-center`}
                              id={"zoneName" + ind + 1 + i?.zoneName}
                              style={{ height: $("#zoneName" + ind + 1 + i?.zoneName).outerHeight() <= $("#vendorName" + ind + 1 + i.zoneApplicableVendors.length).outerHeight() ? $("#vendorName" + ind + 1 + i.zoneApplicableVendors.length).outerHeight() : $("#zoneName" + ind + 1 + i?.zoneName).outerHeight() }}>
                              <td className="break-text remove-border" style={{
                                minWidth: "170px",
                                maxWidth: "190px",
                                width: "170px",
                              }}>
                                <span
                                  className="spanTopBar pl-3 vendor-color"
                                  style={{ cursor: "pointer", textDecorationLine: "underline" }}
                                  onClick={() => this.ZoneTable(i?.zoneName, i?.zoneId)}>
                                  {i.zoneName}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </td>

                        <td
                          className={`${window.innerWidth < 1000 ? "" : ""} text-center align-middle spanTopBar border-right border-bottom border-left px-0`}>
                          {item?.applicableZones.map((i, ind) => (
                            <tr
                              className={`${item?.applicableZones.length - 1 !== ind
                                  ? "border-bottom "
                                  : ""} d-flex justify-content-center`}
                              id={"vendorName" + ind + 1 + i.zoneApplicableVendors.length}
                              style={{ height: $("#zoneName" + ind + 1 + i?.zoneName).outerHeight() <= $("#vendorName" + ind + 1 + i.zoneApplicableVendors.length).outerHeight() ? $("#vendorName" + ind + 1 + i.zoneApplicableVendors.length).outerHeight() : $("#zoneName" + ind + 1 + i?.zoneName).outerHeight() }}>
                              {i?.zoneApplicableVendors.map((j, inde) => (
                                <td className="px-4 break-text remove-border" style={{
                                  minWidth: "170px",
                                  maxWidth: "190px",
                                  width: "170px",
                                }}>
                                  <span
                                    className="spanTopBar vendor-color"
                                    style={{ cursor: "pointer", textDecorationLine: "underline" }}
                                    onClick={() =>
                                      this.VendorTable(j)
                                    }>
                                    {j}
                                  </span>
                                </td>
                              ))}

                            </tr>
                          ))}
                        </td>

                        <td
                          className={`${window.innerWidth < 1000 ? "border-right" : "action"
                            } border-right text-center tableview-set align-middle`}>
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={this.renderedit()}
                          >
                            <i
                              className="fa fa-eye click m-1 px-1"
                              onClick={() => eyeclick(item)}
                              aria-hidden="true"
                              style={{
                                color: "#1a3464",
                                fontSize: "1.3rem",
                              }}></i>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={this.renderdelete()}
                          >
                            <i
                              className="fa fa-trash click m-1 px-1"
                              onClick={() => deleteVendor(item)}
                              aria-hidden="true"
                              style={{
                                color: "#1a3464",
                                fontSize: "1.3rem",
                              }}></i>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    </>
                  );
                })
              ) : (
                <>
                  <tr>
                    <span className="text-center">{t("CommonText.NoItem")}</span>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    ) : null;
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    applicableServiceType:
      state.MasterScreenReducer.applicableServiceTypeInterval,
    menuToggle: state.SidePanReducer.menuToggle,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VendorCard)));
